export default {
      id: "vectorStrokeMb-usage",
      viewBox: "0 0 8 13",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#vectorStrokeMb-usage",
      toString: function () {
        return this.url;
      }
    }